import styled from 'styled-components';

export const MarketplaceDistributionStyled = styled.div`
  background: var(--color-sonata-primary-200, #F2F5FC);
  border-radius: var(--spacing-8);
  padding: var(--spacing-16);
  .marketplaceDistribution {
    &__title {
      font: var(--font-body-500-medium);
      color: var(--color-sonata-primary-800, #162237);
    }

    &__body {
      display: flex;
      flex-direction: column;
      row-gap: 16px;
      padding: 16px;
    }
  }
`;
